module.exports = __webpack_public_path__ + "static/media/18ECA35.4a88a6e8.jpg";